<template>
  <progressive-background
    :src="src(500)"
    :placeholder="src(10)"
    @onLoad="onLoad"
    class="card card-img shadow-sm"
  >
    <div class="content p-2" slot="content">
      <transition name="fade">
        <div v-if="swatches" class="card shadow-sm rounded">
          <div class="container">
            <div class="row">
              <div v-for="(swatch, i) in swatches" :key="i" class="color-box-wrap col-4">
                <color-box :swatch="swatch" isSmall="true" />
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </progressive-background>
</template>

<script>
// Import Vibrant
import * as Vibrant from "node-vibrant";
import ColorBox from "@/components/ColorBox.vue";

let randomWords = require("random-words");

export default {
  name: "sampleImage",
  components: { ColorBox },
  data() {
    return {
      swatches: null,
      seed: randomWords()
    };
  },
  methods: {
    src(res) {
      return `https://picsum.photos/seed/${this.seed}/${res}`;
    },
    onLoad() {
      let self = this;

      Vibrant.from(self.src(300)).getPalette(
        (err, palette) => (self.swatches = palette)
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  position: relative;
  overflow: hidden;
  width: 100%;
}
.card-img {
  min-height: 300px;
  background-color: #eee;
}
.content {
  position: absolute !important;
  width: 100%;
  overflow: hidden;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease-out;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(10px);
}
</style>